import React from 'react';
import { C } from '../utils/theme.js';

export default function NavBtn(props) {
  var active = props.active;
  return (
    <button onClick={props.onClick} style={{
      background: active ? C.a1 + "18" : "transparent",
      color: active ? C.a1 : C.t3,
      border: active ? "1px solid " + C.a1 + "40" : "1px solid transparent",
      borderRadius: 6,
      padding: "4px 12px",
      cursor: "pointer",
      fontSize: 12,
      fontWeight: active ? 600 : 400,
      transition: "all .15s",
      fontFamily: "inherit",
      whiteSpace: "nowrap"
    }}>{props.children}</button>
  );
}
